import { useMemo } from 'react';
import { sprintf } from 'sprintf-js';

import { DropdownChevron } from 'components/Dropdown/Chevron/DropdownChevron';
import { DropdownHeaderTrigger } from 'components/Dropdown/HeaderTrigger/DropdownHeaderTrigger';
import { Hide } from 'components/Hide/Hide';
import { Icon } from 'components/Icon/Icon';
import { MyAccountDropdown } from 'components/MyAccountDropdown/MyAccountDropdown';
import { useLogin } from 'hooks/useLogin';
import { LocalNotificationStatus } from 'types/LocalNotification/LocalNotificationStatus';
import { LocalProductNotificationType } from 'types/LocalNotification/LocalProductNotificationType';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { hasResumeDb, promoteResumeDatabase } from 'utils/resumeDatabase';
import { useLocalNotification } from 'zustand-stores/localNotificationsStore';
import { useUserEnvironment } from 'zustand-stores/userEnvironmentStore';

export function MyAccountDropdownContainer() {
  const userEnvironment = useUserEnvironment();

  const { user, environment } = userEnvironment;
  const displayName = user?.firstName || user?.email || '';

  const resumeNotification = useLocalNotification(
    LocalProductNotificationType.UPLOAD_RESUME,
  );

  const promoteResumeDb = useMemo(
    () =>
      Boolean(
        environment &&
          resumeNotification?.status === LocalNotificationStatus.NEW &&
          promoteResumeDatabase(user, environment),
      ),
    [resumeNotification, user, environment],
  );

  const { onClickLogin, loginLink } = useLogin();

  return (
    <MyAccountDropdown
      trigger={
        <DropdownHeaderTrigger
          variant="grey"
          qaId="nav-dropdown-toggle"
          ariaLabel={getText('Account Information')}
          onClick={() => {
            trackClicked('Header Utility CTA - Hi, Name');
          }}
        >
          <Hide lg xl>
            <Icon name="gear" size={20} />
          </Hide>

          <Hide xs sm md display="flex" alignItems="center">
            {
              /* TRANSLATORS: user greeting at top of page */
              sprintf(getText('Hi, %(name)s!'), { name: displayName })
            }

            <DropdownChevron />
          </Hide>
        </DropdownHeaderTrigger>
      }
      displayName={displayName}
      orgs={user?.orgs || []}
      promoteResumeDb={promoteResumeDb}
      showProfileLink={Boolean(user?.hasIdealistProfileFeature)}
      showEmploymentProfileLink={hasResumeDb(user, environment)}
      hasResume={Boolean(user?.resumeId)}
      isLoggedIn={Boolean(user)}
      loginLink={loginLink}
      onClickLogin={onClickLogin}
    />
  );
}
